import theme from "theme";
import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

export interface IToggle {
  onClick: () => void;
  isOn: boolean;
  children: React.ReactNode;
  count: number;
  icon?: React.ReactNode;
}

const Toggle = ({ onClick, isOn, children, count, icon }: IToggle) => (
  <Tooltip
    title={
      isOn ? (
        <>
          Filter applied
          <br />
          (click again to remove)
        </>
      ) : (
        "Apply this filter"
      )
    }
    placement="top"
  >
    <Stack
      onClick={onClick}
      padding={theme.spacing(0.5, 1)}
      direction="row"
      alignItems="center"
      gap={0.75}
      sx={{
        cursor: "pointer",
        userSelect: "none",
        borderRadius: "2px",
        transition: "all 0.3s linear",
        backgroundColor: isOn ? colors.blue40 : colors.gray5,
        border: `1px solid ${isOn ? colors.blue100 : colors.gray40}`,
        "&:hover": {
          backgroundColor: colors.blue40,
          border: `1px solid ${colors.blue100}`,
        },
      }}
      data-testid="filter-button"
    >
      {icon}

      <Text
        noWrap
        variant="text4"
        fontWeight={500}
        sx={{
          "&::first-letter": {
            textTransform: "uppercase",
          },
        }}
        data-testid="filter-name"
      >
        {children}
      </Text>

      <Text
        variant="labelSmall"
        fontWeight={700}
        color={colors.blue80}
        data-testid="filter-count"
      >
        {count}
      </Text>
    </Stack>
  </Tooltip>
);

export default Toggle;
